import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { filetype } from './validator';

@Directive({
    selector: '[filetype][formControlName],[filetype][formControl],[filetype][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FiletypeValidatorDirective),
            multi: true,
        },
    ],
})
export class FiletypeValidatorDirective implements Validator, OnChanges, OnInit {
    private validator: ValidatorFn;

    @Input()
    allowedTypes: string[] = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

    @Input()
    allowedExtension: string[] = ['.jpeg', '.jpg', '.png', '.pdf'];

    ngOnInit() {
        this.validator = filetype(this.allowedTypes, this.allowedExtension);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('allowedTypes' in changes) {
            this.validator = filetype(this.allowedTypes, this.allowedExtension);
        }
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
